export const isUserVip = (userData) =>
  userData?.isVip === true || userData?.isVip === "true";

const getMessageSenderId = (msg) => {
  if (msg?.msgByUserId && typeof msg.msgByUserId === "object") {
    return msg.msgByUserId._id || msg.msgByUserId.id || null;
  }
  return msg?.msgByUserId || msg?.sender?._id || null;
};

export const isMessageVip = (msg, fallbackUser) => {
  if (msg?.msgByUserId && typeof msg.msgByUserId === "object") {
    if (msg.msgByUserId.isVip === true) return true;
  }
  if (msg?.sender?.isVip === true) return true;

  if (isUserVip(fallbackUser)) {
    const senderId = getMessageSenderId(msg);
    const fallbackId = fallbackUser?._id || fallbackUser?.id;
    if (senderId && fallbackId && String(senderId) === String(fallbackId)) {
      return true;
    }
  }

  return false;
};

export const vipMessageClass = (msg, fallbackUser) =>
  isMessageVip(msg, fallbackUser) ? " is-vip-bubble" : "";
